import { Typography, Box } from '@mui/material';
import { LastDeclaredDate, LastDeclaredShifts, LastDeclaredMissingData } from '../DOAModels';
import { PopupMessage } from '../../../components/PopupMessage';
import { IDOALastDeclared } from '../DOAData';
import { lastDeclaredPopupContainerStyle, lastDeclaredPopupContentStyle, lastDeclaredPopupTextContentStyle, lastDeclaredPopupNoDataStyle, lastDeclaredPopupFlex } from '../styled';

interface LastDeclaredProps {
    onClick: () => void;
    title?: string;
    data?: IDOALastDeclared
}

export const LastDeclaredPopup: React.FC<LastDeclaredProps> = ({
    onClick,
    title = 'Last Declared',
    data
}) => (
    <Box sx={lastDeclaredPopupContainerStyle}>
        <Box sx={lastDeclaredPopupContentStyle}>
            <PopupMessage title={title} onClose={onClick}>

                {(!data || !data?.lastDeclaredShifts.length) && <Typography sx={lastDeclaredPopupNoDataStyle} data-automation="last-declared-content">
                    <Typography sx={{ mb: 1}}>
                        <Typography data-automation="last-declared-date-lbl">{LastDeclaredMissingData}</Typography>
                    </Typography>
                </Typography>}

                {(data && data?.lastDeclaredShifts.length > 0) && <Typography sx={lastDeclaredPopupTextContentStyle} data-automation="last-declared-content">
                    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 1}}>
                        <Box sx={{ mb: 5 }}>
                            <Typography sx={lastDeclaredPopupFlex}>
                                <Typography sx={{ fontWeight: 'bold'}} data-automation="last-declared-date-lbl">{LastDeclaredDate}</Typography>
                                <Typography sx={{ ml: 2.5 }} data-automation="last-declared-date-val">
                                        {data?.lastDeclaredDate}
                                </Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={lastDeclaredPopupFlex}>
                                <Typography sx={{ fontWeight: 'bold'}} data-automation="last-declared-shifts-lbl">{LastDeclaredShifts}</Typography>
                                <Box>
                                    <Typography sx={{ ml: 1, mb: 1 }} data-automation="last-declared-date-val">
                                        {data?.lastDeclaredShifts
                                        && data.lastDeclaredShifts.map((shift, index) => (
                                            <Typography key={index}>{shift}</Typography>))}
                                    </Typography>
                                </Box>
                            </Typography>
                        </Box>
                    </Box>
                </Typography>}


            </PopupMessage>
        </Box>
      </Box>
)